import { configureStore } from '@reduxjs/toolkit'
import { thunk } from 'redux-thunk'
import rootReducer from './slices/index.js'

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(thunk),
  preloadedState: window.__PRELOADED_STATE__ || {},
})

delete window.__PRELOADED_STATE__

export default store
